module.exports = "/davinci/assets/e801e1f9fc73074f45c045df40615c91.png";